import { Stack, TabPanel, TabPanelProps, VStack } from '@chakra-ui/react';
import { TransactionType } from 'api';
import { ClientContext } from 'core';
import { useContext, useState } from 'react';
// import {
//   StepSetTbl,
//   TransactionType,
//   TransactionTypeAfe,
//   TransactionTypeInvoice,
//   TransactionTypePurchaseOrder,
//   TransactionTypeWorkOrder,
// } from 'types';
import { ClientApproversSection } from './ClientApproversSection';
import {
  ClientApproversFormDrawer,
  ClientApproversFormDrawerProps,
} from './ClientApproversFormDrawer';

export interface ClientApproversTabPanelProps extends TabPanelProps {}
export const ClientApproversTabPanel = (
  props: ClientApproversTabPanelProps
) => {
  const { ...others } = props;
  const client = useContext(ClientContext);

  const [editState, setEditState] =
    useState<Omit<ClientApproversFormDrawerProps, 'onClose' | 'onSubmit'>>();

  return (
    <TabPanel {...others}>
      <Stack>
        <VStack spacing={8}>
          <ClientApproversSection
            width={'100%'}
            size="md"
            heading="AFE's"
            clientId={client.id}
            settings={client.afeTransactionRoutingSettings}
            assigneeApprovalOptional={true}
            onEdit={() =>
              setEditState({
                isOpen: true,
                client,
                transactionType: TransactionType.Afe,
                heading: 'AFE Approver Settings',
                settings: client?.afeTransactionRoutingSettings as any, // TODO: Oof, must fix
                assigneeApprovalOptional: true,
              })
            }
            onDelete={() => {}}
          />
          <ClientApproversSection
            width={'100%'}
            size="md"
            heading="Purchase Orders"
            clientId={client.id}
            settings={client.purchaseOrderTransactionRoutingSettings}
            assigneeApprovalOptional={true}
            onEdit={() =>
              setEditState({
                isOpen: true,
                client,
                transactionType: TransactionType.PurchaseOrder,
                heading: 'Purchase Order Approver Settings',
                settings:
                  client?.purchaseOrderTransactionRoutingSettings as any, // TODO: Oof, must fix
                assigneeApprovalOptional: true,
              })
            }
            onDelete={() => {}}
          />
          <ClientApproversSection
            width={'100%'}
            size="md"
            heading="Work Orders"
            clientId={client.id}
            settings={client?.workOrderTransactionRoutingSettings}
            assigneeApprovalOptional={true}
            onEdit={() =>
              setEditState({
                isOpen: true,
                client,
                transactionType: TransactionType.WorkOrder,
                heading: 'Work Order Approver Settings',
                settings: client?.workOrderTransactionRoutingSettings as any, // TODO: Oof, must fix
                assigneeApprovalOptional: true,
              })
            }
            onDelete={() => {}}
          />
          <ClientApproversSection
            width={'100%'}
            size="md"
            heading="Invoices"
            clientId={client.id}
            settings={client.invoiceTransactionRoutingSettings}
            assigneeApprovalOptional={false}
            onEdit={() =>
              setEditState({
                isOpen: true,
                client,
                transactionType: TransactionType.Invoice,
                heading: 'Invoice Approver Settings',
                settings: client?.invoiceTransactionRoutingSettings as any, // TODO: Oof, must fix
                assigneeApprovalOptional: false,
              })
            }
            onDelete={() => {}}
          />
        </VStack>
      </Stack>
      {editState && (
        <ClientApproversFormDrawer
          {...editState}
          onClose={() => setEditState(undefined)}
        />
      )}
    </TabPanel>
  );
};
